var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_534_1551",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.485352,
    y: 0.243683,
    width: 23.6633,
    height: 23.6633,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_534_1551)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3167 12.0753C11.2321 12.0753 10.3037 11.6891 9.53135 10.9168C8.75901 10.1444 8.37283 9.21599 8.37283 8.13143C8.37283 7.04686 8.75901 6.1184 9.53135 5.34606C10.3037 4.57372 11.2321 4.18755 12.3167 4.18755C13.4013 4.18755 14.3297 4.57372 15.1021 5.34606C15.8744 6.1184 16.2606 7.04686 16.2606 8.13143C16.2606 9.21599 15.8744 10.1444 15.1021 10.9168C14.3297 11.6891 13.4013 12.0753 12.3167 12.0753ZM4.42896 19.9631V17.2023C4.42896 16.6436 4.57274 16.1301 4.86032 15.6618C5.14789 15.1934 5.52995 14.836 6.00651 14.5895C7.02534 14.0801 8.06061 13.698 9.11231 13.4433C10.164 13.1886 11.2321 13.0613 12.3167 13.0613C13.4013 13.0613 14.4694 13.1886 15.5211 13.4433C16.5728 13.698 17.6081 14.0801 18.6269 14.5895C19.1035 14.836 19.4855 15.1934 19.7731 15.6618C20.0607 16.1301 20.2045 16.6436 20.2045 17.2023V19.9631H4.42896Z",
    fill: "#4E5154"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.da36248e7d8b9a51986e55e40652dee6.svg";
export { ForwardRef as ReactComponent };